/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tcType: NonNullable<unknown> }} Input_Tc_Input_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Timecode input for {tcType}" |
*
* @param {Input_Tc_Input_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_input_aria_label = /** @type {((inputs: Input_Tc_Input_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Input_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Saisie de timecode pour ${i?.tcType}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Timecode-Eingabe für ${i?.tcType}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Input timecode per ${i?.tcType}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ввод временного кода для ${i?.tcType}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Entrada de código de tiempo para ${i?.tcType}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.tcType} 的时间码输入`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.tcType} のタイムコード入力`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.tcType} के लिए टाइमकोड इनपुट`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Entrada de código de tempo para ${i?.tcType}`)
	return /** @type {LocalizedString} */ (`Timecode input for ${i?.tcType}`)
});